import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import AdStrip from "../components/AdStrip";

const Discover = () => {
  const [feed, setFeed] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/discover").then((r) => setFeed(r.data.feed)).finally(() => setLoading(false));
  }, []);

  return (
    <div className="max-w-[1400px] mx-auto px-6 sm:px-10 py-12">
      <div className="grid grid-cols-12 gap-6 border-b border-black/10 pb-8 mb-12">
        <div className="col-span-12 md:col-span-8">
          <div className="font-mono-eyebrow">Feed · The house floor</div>
          <h1 className="font-serif-display text-5xl md:text-7xl leading-none mt-2">Discover<br/><em className="text-[color:var(--accent)]">the wardrobe of others.</em></h1>
        </div>
        <div className="col-span-12 md:col-span-4 md:self-end">
          <p className="text-black/60 leading-relaxed">A daily rotation of looks published by other members. Borrow silhouettes. Shop the pieces. Remix into your own.</p>
        </div>
      </div>

      {loading ? (
        <div className="py-20 text-center font-mono-eyebrow">Curating…</div>
      ) : feed.length === 0 ? (
        <div className="py-24 text-center">
          <p className="font-serif-display text-4xl">The runway is empty… for now.</p>
          <p className="text-black/60 mt-2 font-mono-eyebrow">Be the first — publish an outfit from your archive.</p>
          <Link to="/outfits" className="btn-ink mt-6 inline-block">Open your archive</Link>
        </div>
      ) : (
        <div className="grid grid-cols-12 gap-6">
          {feed.map(({ outfit, items, tryon }, idx) => {
            // asymmetric size — varies col-span by idx for editorial layout
            const span = idx % 5 === 0 ? "md:col-span-8 lg:col-span-7" : idx % 3 === 0 ? "md:col-span-6 lg:col-span-5" : "md:col-span-6 lg:col-span-4";
            return (
              <motion.article
                key={outfit.id}
                initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
                transition={{ duration: 0.5, delay: (idx % 6) * 0.06 }}
                className={`col-span-12 ${span} bg-white border border-black/10 relative`}>
                <Link to={`/outfits/${outfit.share_slug}`}>
                  <div className="aspect-[3/4] overflow-hidden bg-neutral-100">
                    {tryon ? (
                      <img src={tryon.result_data_url} alt={outfit.name} className="w-full h-full object-cover hover:scale-[1.02] transition-transform duration-700"/>
                    ) : (
                      <div className="grid grid-cols-2 h-full">
                        {items.slice(0, 4).map((it) => (
                          <img key={it.id} src={it.image_url} alt="" className="w-full h-full object-cover"/>
                        ))}
                      </div>
                    )}
                  </div>
                  <div className="p-5 flex items-end justify-between gap-6">
                    <div className="min-w-0">
                      <div className="font-mono-eyebrow text-black/40">{outfit.user_name} · N° {outfit.id.slice(0,4)}</div>
                      <div className="font-serif-display text-2xl leading-tight truncate">{outfit.name}</div>
                    </div>
                    <div className="text-right shrink-0">
                      <div className="font-mono-eyebrow text-black/60 whitespace-nowrap">{items.length} pcs</div>
                      {(outfit.like_count > 0) && (
                        <div className="font-mono-eyebrow text-[color:var(--accent)] whitespace-nowrap mt-1 flex items-center justify-end gap-1">
                          ♥ {outfit.like_count}
                        </div>
                      )}
                    </div>
                  </div>
                </Link>
                <div className="absolute top-4 left-4 bg-white/90 backdrop-blur px-3 py-1 font-mono-eyebrow">N° {String(feed.length - idx).padStart(3, "0")}</div>
              </motion.article>
            );
          })}
        </div>
      )}

      <AdStrip slot="discover" heading="Featured houses" subheading="Sponsored · Discover the labels" limit={4}/>
    </div>
  );
};

export default Discover;
